import { mapMutations } from 'vuex';

// FavoriteSelectBookMixin
export const FavoriteSelectCourseMixin = {
  name: 'FavoriteSelectCourseMixin',

  methods: {
    ...mapMutations('Mixins/Bookmark', {
      mm_SET_SELECTED_COURSE_ID: 'SET_SELECTED_COURSE_ID',
    }),

    selectCourse(courseId) {
      this.mm_SET_SELECTED_COURSE_ID(courseId);
      this.selectBook(-1);
    },
  },
};
